module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail2.fe8d0b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail2.jpg
// module id = A9j4
// module chunks = 6